import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

interface IStyles {
    backgroundImage?: string;
}
export const useStyles = makeStyles<IStyles>()(
    (theme, { backgroundImage }) => ({
        card: {
            cursor: "pointer",
            width: "360px",
            height: "240px",
            display: "flex",
            background: backgroundImage
                ? `url(${backgroundImage})`
                : constants.color.black,
            backgroundPosition: "top left",
            backgroundSize: "130%",
            backgroundRepeat: "no-repeat",
            position: "relative",

            "& .gradient": {
                position: "absolute",
                top: 0,
                left: 0,
                width: "inherit",
                height: "inherit",
                background:
                    "linear-gradient(110.35deg, #1A1A1A 3.49%, #121212 52.7%)",
                borderImageSource:
                    "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #2B2B2B 100%)",
                opacity: "0.7",
                zIndex: 0,
            },
        },

        cardMessage: {
            fontFamily: "Gotham Book",
            fontSize: "30px",
            fontWeight: 410,
            lineHeight: "35px",
            letterSpacing: "2px",
            textAlign: "left",
            zIndex: 1,
            margin: "38px 0 0 30px",
            textTransform: "uppercase",
            width: "328px",
            color: constants.color.white,
        },
    })
);
